import { useState } from "react";
import CaseAi from "../../CasePage/CaseAI/CaseAi";
import { AiCrossIcon, AiQuestionMarkIcon } from "../../common/Icons";
import { ActionButton, Tooltip, TooltipTrigger } from "@adobe/react-spectrum";

const CaseAiDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => setIsOpen(!isOpen);

  return (
    <div className={`drawer ${isOpen ? "open" : "closed"}`}>
      <div className="case-ai-toggle-button" onClick={toggleDrawer}>
        {isOpen ? (
          <AiCrossIcon />
        ) : (
          <span>
            <TooltipTrigger delay={0} placement="left">
              <ActionButton
                aria-label="ask ai"
                UNSAFE_style={{
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onPress={toggleDrawer}
              >
                <AiQuestionMarkIcon />
              </ActionButton>
              <Tooltip>Ask AI</Tooltip>
            </TooltipTrigger>
          </span>
        )}
      </div>
      {isOpen && (
        <>
          <CaseAi caseID="" />
        </>
      )}
    </div>
  );
};

export default CaseAiDrawer;
